export enum ModalType {
  TEXT = 'TEXT',
  DOBRY_PRAD = 'DOBRY_PRAD',
}
